import React, { useState, useEffect } from 'react';

import 'moment/locale/es';
import moment from 'moment';

import { makeStyles } from '@material-ui/core';

import Datatable from '../../../shared/ui/components/Datatable';
import getCustomerInvoiceList from 'src/customer-invoice/use-cases/getCustomerInvoiceList';

const CustomerInvoiceDatatable = ({
  customerId,
  handleDownload,
  handleAdd,
  handleAddPayment,
  handleEdit
}) => {
  const companyHeadquarterId = localStorage.selectedUserHeadquarter;
  const [list, setList] = useState({
    rows: [],
    count: 0
  });
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(100);
  const [orderBy, setOrderBy] = useState({
    columnName: null,
    orderBy: null
  });

  const fetchList = async () => {
    const response = await getCustomerInvoiceList({
      companyHeadquarterId,
      customerId,
      search: search,
      orderBy: orderBy.columnName
        ? `${orderBy.columnName} ${orderBy.orderBy}`
        : '',
      page,
      limit
    });

    response.rows = response.rows.map((x) => {
      let monthNameTermList = {
        monthNameTermList: Array.from(
          new Set(
            x.customerTermList.map((y) =>
              moment(y.date)
                .format('MMMM')
                .toUpperCase()
            )
          )
        ).join(' ')
      };
      return {
        ...x,
        ...monthNameTermList
      };
    });

    setList(response);
  };

  useEffect(() => {
    fetchList();
  }, [page, limit, search, orderBy]);

  const handleSearch = (searchValue) => {
    setPage(0);
    setSearch(searchValue.target.value);
  };

  const handleChangePage = (pageIndex) => {
    setPage(pageIndex);
  };

  const handleChangeLimit = (limitIndex) => {
    setLimit(limitIndex);
  };

  const handleOrderBy = (column) => {
    setOrderBy(column);
  };

  const handleClickDownload = (event, id) => {
    handleDownload(id);
  };

  const handleClickEdit = (event, id) => {
    handleEdit(id);
  };

  const columnNameList = [
    'date',
    'invoiceStampingNumber',
    'number',
    'monthNameTermList|date',
    'CustomerInvoiceStatus.code',
    'billToCustomerContact.zoneCode',
    '${billToCustomerContact.firstname}${billToCustomerContact.surnames}|billToCustomerContact.firstname',
    'billToCustomerContact.document',
    'billToCustomerContact.phone1',
    '${MoneyCollectionCustomerContact.firstname}${MoneyCollectionCustomerContact.surnames}|MoneyCollectionCustomerContact.firstname',
    'MoneyCollectionCustomerContact.phone1',
    'MoneyCollectionCustomerContact.paymentTypeNameList|MoneyCollectionCustomerContact.paymentTypeListId',
    'PromisePayment.promiseDate',
    'hasValidPromisePayment',
    'MoneyCollectionCustomerContact.preferredPaymentDay',
    'scheduledPaymentDate',
    'comments',
    'amount',
    'rest'
  ];

  return (
    <Datatable
      domainName="CUSTOMER_INVOICE"
      dataList={list.rows}
      count={list.count}
      addButtonText=""
      addButtonRoute={false}
      title="Facturas"
      exportExcelButton={Boolean(false)}
      onSearch={handleSearch}
      onChangePageValue={handleChangePage}
      onChangePageLimit={handleChangeLimit}
      handleOrderBy={handleOrderBy}
      handleClickAdd={() => {}}
      handleClickEdit={handleClickEdit}
      handleClickDownload={handleClickDownload}
      columnNameList={columnNameList}
    />
  );
};

export default CustomerInvoiceDatatable;
